import { RESOLVERS_IDS } from './resolvers/resolvers-ids';
import {
  alwaysActiveResolver,
  alwaysVisibleResolver,
  getAlignmentInSelectionResolver,
  getFontSizeInSelectionResolver,
  getHeadingInSelectionResolver,
  getHighlightColorInSelectionResolver,
  getLineSpacingAfterSelectionResolver,
  getLineSpacingBeforeSelectionResolver,
  getLineSpacingInSelectionResolver,
  getTextColorInSelectionResolver,
  isHeaderTwoOrThreeSelected,
  isNodeOrCaptionSelected,
  isNodeSelected,
  isRedoStackEmptyResolver,
  isTextAlignCenter,
  isTextAlignJustify,
  isTextAlignLeft,
  isTextAlignRight,
  isTextContainsAnchorResolver,
  isTextContainsBoldResolver,
  isTextContainsCodeblockResolver,
  isTextContainsItalicResolver,
  isTextContainsLinkOrAnchorResolver,
  isTextContainsLinkResolver,
  isTextContainsOrderedListResolver,
  isTextContainsQuoteResolver,
  isTextContainsSpoilerResolver,
  isTextContainsUnderlineResolver,
  isTextContainsUnorderedListResolver,
  isTextInSelection,
  isTextStylesMatchDocumentStylesResolver,
  isUndoStackEmptyResolver,
} from './resolvers/tiptapResolvers';

export const resolversById = {
  [RESOLVERS_IDS.ALWAYS_VISIBLE]: alwaysVisibleResolver,
  [RESOLVERS_IDS.ALWAYS_ACTIVE]: alwaysActiveResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_ANCHOR]: isTextContainsAnchorResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_BOLD]: isTextContainsBoldResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_CODE_BLOCK]: isTextContainsCodeblockResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_ITALIC]: isTextContainsItalicResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_LINK]: isTextContainsLinkResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_LINK_OR_ANCHOR]: isTextContainsLinkOrAnchorResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_ORDERED_LIST]: isTextContainsOrderedListResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_QUOTE]: isTextContainsQuoteResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_UNDERLINE]: isTextContainsUnderlineResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_UNORDERED_LIST]: isTextContainsUnorderedListResolver,
  [RESOLVERS_IDS.IS_TEXT_IN_SELECTION]: isTextInSelection,
  [RESOLVERS_IDS.GET_HEADING_IN_SELECTION]: getHeadingInSelectionResolver,
  [RESOLVERS_IDS.GET_HIGHLIGHT_COLOR_IN_SELECTION]: getHighlightColorInSelectionResolver,
  [RESOLVERS_IDS.GET_TEXT_COLOR_IN_SELECTION]: getTextColorInSelectionResolver,
  [RESOLVERS_IDS.GET_LINE_SPACING_IN_SELECTION]: getLineSpacingInSelectionResolver,
  [RESOLVERS_IDS.GET_LINE_SPACING_BEFORE_SELECTION]: getLineSpacingBeforeSelectionResolver,
  [RESOLVERS_IDS.GET_LINE_SPACING_AFTER_SELECTION]: getLineSpacingAfterSelectionResolver,
  [RESOLVERS_IDS.GET_ALIGNMENT_IN_SELECTION]: getAlignmentInSelectionResolver,
  [RESOLVERS_IDS.GET_FONT_SIZE_IN_SELECTION]: getFontSizeInSelectionResolver,
  [RESOLVERS_IDS.IS_TEXT_CONTAINS_SPOILER]: isTextContainsSpoilerResolver,
  [RESOLVERS_IDS.IS_TEXT_STYLES_MATCH_DOCUMENT_STYLES]: isTextStylesMatchDocumentStylesResolver,
  [RESOLVERS_IDS.IS_UNDO_STACK_EMPTY]: isUndoStackEmptyResolver,
  [RESOLVERS_IDS.IS_REDO_STACK_EMPTY]: isRedoStackEmptyResolver,
  [RESOLVERS_IDS.IS_NODE_SELECTED]: isNodeSelected,
  [RESOLVERS_IDS.IS_NODE_OR_CAPTION_SELECTED]: isNodeOrCaptionSelected,
  [RESOLVERS_IDS.IS_HEADER_TWO_OR_THREE_SELECTED]: isHeaderTwoOrThreeSelected,
  [RESOLVERS_IDS.IS_TEXT_ALIGN_LEFT]: isTextAlignLeft,
  [RESOLVERS_IDS.IS_TEXT_ALIGN_CENTER]: isTextAlignCenter,
  [RESOLVERS_IDS.IS_TEXT_ALIGN_RIGHT]: isTextAlignRight,
  [RESOLVERS_IDS.IS_TEXT_ALIGN_JUSTIFY]: isTextAlignJustify,
};

export { LinkButton } from './components/buttons';
export { Toolbar, TOOLBAR_DATA_HOOK, TOOLBAR_VISIBLE } from './components/Toolbar';
export { Content } from './Content';
export { defaultToolbarItemsConfigs } from './default-toolbar-items-configs';
export { default as AddPluginMenuHorizontal } from './modals/FloatingPluginMenu/AddPluginMenuHorizontal';
export { default as FloatingAddPluginMenu } from './modals/FloatingPluginMenu/FloatingAddPluginMenu';
export {
  alwaysActiveResolver,
  alwaysVisibleResolver,
  getAlignmentInSelectionResolver,
  getAnchorLinkData,
  getFontSizeInSelectionResolver,
  getHeadingInSelectionResolver,
  getHighlightColorInSelectionResolver,
  getLineSpacingAfterSelectionResolver,
  getLineSpacingBeforeSelectionResolver,
  getLineSpacingInSelectionResolver,
  getNodeAlignmentResolver,
  getNodeInSelectionResolver,
  getNodeLinkDataResolver,
  getNodeSizeResolver,
  getNodeTextWrapResolver,
  getTextColorInSelectionResolver,
  getUrlLinkData,
  isHeaderTwoOrThreeSelected,
  isNodeContainsLinkOrAnchorResolver,
  isNodeOrCaptionSelected,
  isNodeSelected,
  isRedoStackEmptyResolver,
  isTextAlignCenter,
  isTextAlignJustify,
  isTextAlignLeft,
  isTextAlignRight,
  isTextContainsAnchorResolver,
  isTextContainsBoldResolver,
  isTextContainsCodeblockResolver,
  isTextContainsItalicResolver,
  isTextContainsLinkOrAnchorResolver,
  isTextContainsLinkResolver,
  isTextContainsOrderedListResolver,
  isTextContainsQuoteResolver,
  isTextContainsSpoilerResolver,
  isTextContainsUnderlineResolver,
  isTextContainsUnorderedListResolver,
  isTextInSelection,
  isTextStylesMatchDocumentStylesResolver,
  isUndoStackEmptyResolver,
} from './resolvers/tiptapResolvers';
export {
  FLOATING_FORMATTING_TOOLBAR,
  FLOATING_PLUGIN_TOOLBAR,
  FloatingFormattingToolbar,
  FOOTER_TOOLBAR,
  FooterToolbar,
  FORMATTING_ORIENTATIONS_SWITCH,
  FORMATTING_TOOLBAR,
  FormattingToolbar,
  MEGA_TOOLBAR,
  MegaToolbar,
  MOBILE_TOOLBAR,
  MobileToolbar,
  PLUGINS_ORIENTATIONS_SWITCH,
  PluginsToolbar,
  STATIC_TOOLBAR_DATA_HOOK,
  StaticToolbar,
} from './ricos-toolbars';
export { RicosToolbars } from './ricos-toolbars/ricos-toolbars';
